import React from 'react'
// import {NavLink} from 'react-router-dom'
import BsNavbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'
// import NavDropdown from "react-bootstrap/NavDropdown";

import {Props, State} from './NavbarModel'
// import {navbar} from 'AppRoute/AppRouteConstant'
import {navLink} from './NavbarConstants'
import {animatedBrandTitle} from './NavbarHelper'

export default class Navbar extends React.Component<Props, State> {
	static defaultProps: Partial<Props> = {}

	componentDidMount() {
		animatedBrandTitle()
	}

	render() {
		return (
			<BsNavbar sticky='top' collapseOnSelect expand='lg' variant='dark' className='d-flex w-100 bg-secondary-one'>
				<BsNavbar.Brand id='brand-title' className='w-240px font-weight-bold'></BsNavbar.Brand>
				<BsNavbar.Toggle aria-controls='responsive-navbar-nav' />
				<BsNavbar.Collapse id='responsive-navbar-nav'>
					<Nav className='mr-auto'>
						{/* {navbar.map((route, index) => {
							return (
								<NavLink to={route.path} className='px-4' activeClassName='active-menu' key={index.toString()}>
									{route.title}
								</NavLink>
							)
						})} */}
						{/* <NavDropdown title="Dropdown" id="collasible-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item>
            </NavDropdown> */}
					</Nav>
					<Nav>
						{navLink.map((item, index) => {
							return (
								<Nav.Link href={item.href} target={item.target} key={`navlink${index}`}>
									<i className={item.icon} title={item.title}></i>
								</Nav.Link>
							)
						})}
					</Nav>
				</BsNavbar.Collapse>
			</BsNavbar>
		)
	}
}
